import { render, staticRenderFns } from "./ArtworkRow.vue?vue&type=template&id=9cd053ce&scoped=true&"
import script from "./ArtworkRow.vue?vue&type=script&lang=js&"
export * from "./ArtworkRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=9cd053ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd053ce",
  null
  
)

export default component.exports